import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonColorEnum } from 'src/app/shared/buttons/enums/button-color.enum';
import { GetIncidentsImportDetailResponse } from '../../incidents-import.model';
import { IncidentsDetailStatusEnum } from './incidents-detail-status.enum';

@Component({
  selector: 'app-incidents-import-detail-item',
  templateUrl: './incidents-import-detail-item.component.html',
  styleUrls: ['./incidents-import-detail-item.component.scss'],
})
export class IncidentsImportDetailItemComponent {
  showEditUserModal: boolean = false;
  userId: string = '';

  ButtonColorEnum = ButtonColorEnum;
  IncidentsDetailStatusEnum = IncidentsDetailStatusEnum;

  @Input() data: GetIncidentsImportDetailResponse = {
    incidentId: '',
    createdOn: '',
    subCell: '',
    status: '',
    errorMessage: '',
  };

  @Output() import: EventEmitter<string> = new EventEmitter<string>();
}
